import React from 'react'
import Button from '../../../general/Button'

const ImageDisplayAndDelete = ({field = 0, index = 0, image, imagePosition, imagePositionX, isDisabled, imageSize = false, onDeleteImage, imageType}) => {
    if(image) {
        const hasCustomSize = false !== imageSize
        let formatClass 
        let sizeQuery = ''

        if(hasCustomSize) {
            formatClass = 'item-custom-size'
        } else if(field && field.name && (field.name === 'movie.images.poster' || image.format === "portrait")) {
            formatClass = 'item-poster-format' // ToDo: should not be item-poster-format
        } else {
            formatClass = 'item-poster-format landscape-poster' // ToDo: should not be item-poster-format
        }

        if(image.url && (image.url.search("orchestrationlayer.cloudticket.net") !== -1 || image.url.search("cineorder-content-uat.cloudticket.net") !== -1 ||image.url.search("contentservice.cineorder.shop") !== -1)) {
            if(imageType === 'backgrounds' || imageType === 'ambient') {
                sizeQuery = "&size=2000"
            } else {
                sizeQuery = "&size=400"
            }
        }    

        const styles  = {
            backgroundImage: image.url ? `url(${image.url + sizeQuery})` : 'none'
        }
        
        const positionStylingY = {
            top: imagePosition ? imagePosition + '%' : image.positionY ? image.positionY + '%' : image.position ? image.position + '%' : '0%'
        }
      
        const positionStylingX = {
            left: imagePositionX ? imagePositionX + '%' : image.positionX ? image.positionX + '%' : '0%'
        }

        const styleCustomWidth = hasCustomSize ? {
            width: parseFloat((imageSize.width / imageSize.relativeTo) * 100) + '%'
        } : {}

        const sizeStyling = hasCustomSize ? {
            paddingTop: parseFloat((imageSize.height / imageSize.width) * 100) + '%'
        } : {}
        

        return (
            <div className={"image-display " + formatClass}>
                <div className={formatClass} style={styleCustomWidth}>
                    {hasCustomSize ? (
                        // ToDo: Use in any case with size wrapper

                        <div className="item-size-wrapper" style={sizeStyling}>
                            <div className="item-crossed-wrapper">
                                <div className="item-image" style={styles} />
                            </div>
                        </div>
                    ): (
                        <div className="item-image" style={styles} />
                    )}

                    <div className="item-title-wrapper title-item-empty" />

                    {((image.id && (image.position || image.positionY)) || imagePosition) && <div className="show-position-wrapper">
                        <div className="show-position" style={positionStylingY} />
                    </div>}
                    
                    {((image.id && image.positionX) || imagePositionX) && <div className="show-position-wrapper">
                        <div className="show-position x-axis" style={positionStylingX} />
                    </div>}
                    
                    <Button
                        className="button button-delete-item"
                        transId="remove_button"
                        onClick={() => onDeleteImage(index)}
                        hideText={true}
                        disabled={isDisabled}
                    />
                </div>
            </div>
        )
    } else {
        return ''
    }
}

export default ImageDisplayAndDelete